<template>
  <div class="nftinfo">
    <el-dialog :title="title" :visible.sync="boxShow" width="90%" :before-close="closeBox">
      <el-form :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="语言" prop="languageObj">
          <el-checkbox-group v-model="form.languageObj" @change="$forceUpdate()">
            <el-checkbox
              v-for="lang in languages"
              :label="lang.value"
              :key="lang.value"
            >{{lang.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="名称" prop="nameObj" style="margin-top: 20px">
          <span class="star">*</span>
          <div
            v-for="lang in form.languageObj"
            :key="lang"
            style="display: inline-block; margin-right: 10px;"
          >
            <el-input
              :value="nameObj[lang]"
              maxlength="50"
              :rules="[{ required: true, message: '名称不能为空'}]"
              :placeholder="languagesObj[lang]+'名称'"
              @change="nameObjChange(lang, $event)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="等级" prop="grade">
          <el-select v-model="form.grade" placeholder="请选择等级">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合约地址" prop="contractAddress">
          <el-input class="width300" v-model="form.contractAddress" maxlength="50" placeholder="请输入合约地址"></el-input>
        </el-form-item>
        <el-form-item label="Token ID" prop="coinId">
          <el-input v-model="form.coinId" placeholder="请输入ID" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="所属链" prop="chainType">
          <el-select v-model="form.chainType" placeholder="请选择所属链">
            <el-option v-for="item in chainTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创作者" prop="creatorObj" style="margin-top: 20px">
          <div
            v-for="lang in form.languageObj"
            :key="lang"
            style="display: inline-block; margin-right: 10px;"
          >
            <el-input
              :value="creatorObj[lang]"
              maxlength="50"
              :placeholder="languagesObj[lang]+'名'"
              @change="creatorObjChange(lang, $event)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="图片链接" prop="picLinkUrl">
          <el-input class="width300" v-model="form.picLinkUrl" placeholder="请输入图片链接"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="describeInfo" style="margin-top: 20px">
          <div
            v-for="lang in form.languageObj"
            :key="lang"
            style="display: inline-block; margin-right: 10px;"
          >
            <el-input
              :value="describeInfoObj[lang]"
              maxlength="50"
              class="width300"
              :placeholder="languagesObj[lang]+'描述'"
              @change="describeInfoObjChange(lang, $event)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="图片" prop="picUrl">
          <span class="star">*</span>
          <uploadMoulde
            :value="form.picUrl"
            style="display: inline-block"
            :limitNumber="1"
            v-on:input="getSucessInfo"
            ref="childUpload"
          ></uploadMoulde>
        </el-form-item>
        <!-- <el-form-item label="图片" prop="projectDetailObj.banner" style="margin-top: 20px">
          <div
            v-for="lang in languageObj"
            :key="lang"
            style="display: inline-block;margin-right: 10px;vertical-align: top;width: 360px;overflow: hidden"
          >
            <span>{{languagesObj[lang]}}</span>
            <uploadMoulde
              :value="projectDetailObj.banner[lang]"
              :limitNumber="1"
              v-on:input="getSucessInfoBananr(lang,$event)"
              ref="childUpload"
            ></uploadMoulde>
          </div>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBox">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LANGUAGES from "../../../common/languages_code";
import uploadMoulde from "../../../components/upload/indexLimit.vue";
import api from "../api";
import "../store";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    uploadMoulde
  },
  props: {
    title: {
      type: String,
      default: "创建NFT"
    },
    boxShow: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: {}
    },
    editStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      languages: Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      })),
      languagesObj: LANGUAGES,
      form: {
        languageObj: ["zh"]
      },
      nameObj: {},
      name: "",
      creator: "",
      creatorObj: {},
      describeInfo: "",
      describeInfoObj: {},
      projectDetailObj: {
        banner: { zh: "" }
      },
      levelList: [
        {
          label: "一星",
          value: 1
        },
        {
          label: "二星",
          value: 2
        },
        {
          label: "三星",
          value: 3
        },
        {
          label: "四星",
          value: 4
        },
        {
          label: "五星",
          value: 5
        }
      ],
      chainTypeList: [],
      rules: {
        languageObj: [{ required: true, message: "请选择语言" }],
        grade: [
          {
            required: true,
            message: "请选择等级",
            trigger: "change"
          }
        ],
        contractAddress: [
          { required: true, message: "请输入合约地址", trigger: "blur" },
          { max: 50, message: "长度不能超过50个字符", trigger: "blur" }
        ],
        coinId: [
          { required: true, message: "请输入ID", trigger: "blur" },
          { max: 50, message: "长度不能超过50个字符", trigger: "blur" }
        ],
        chainType: [
          {
            required: true,
            message: "请选择所属链",
            trigger: "change"
          }
        ],
        picLinkUrl: [
          { required: true, message: "请输入图片链接", trigger: "blur" }
        ],
        rowId: ''
        // picUrl: [{ required: true, message: "请上传图片" }],
        // "nameObj": [{ required: true, message: "请输入名称" }],
        // creatorObj: [{ required: true, message: "请输入创作者" }],
        // "projectDetailObj.banner": [
        //   { required: true, message: "请填上传项目Banner" }
        // ]
      },
      isTrue: false
    };
  },
  watch: {
    row: {
      handler(value, old) {
        // console.log(value, old);
        if (Object.keys(value).length === 0) return;
        this.rowId = value.id
        // this.getInfo(value.id)
        // this.form = Object.assign(this.form, value);
        // this.$set(this.form, "languageObj", JSON.parse(value.language));
        // this.nameObj = Object.assign(
        //   this.nameObj,
        //   JSON.parse(value.rewardName)
        // );
        // this.creatorObj = Object.assign(
        //   this.creatorObj,
        //   JSON.parse(value.creator)
        // );
        // this.describeInfoObj = Object.assign(
        //   this.describeInfoObj,
        //   JSON.parse(value.describeInfo)
        // );
        this.$forceUpdate();
      },
      immediate: true,
      deep: true
    },
    editStatus: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getInfo(this.rowId)
        }
      }
    }
  },
  methods: {
    ...mapActions("nft", ["getNFTListA"]),
    getList(data = {}) {
      this.getNFTListA({
        ...this.pagination,
        ...data
      });
    },
    nameObjChange(lang, value) {
      this.nameObj[lang] = value;
      this.name = JSON.stringify(this.nameObj);
      this.$forceUpdate();
    },
    creatorObjChange(lang, value) {
      this.creatorObj[lang] = value;
      this.creator = JSON.stringify(this.creatorObj);
      this.$forceUpdate();
    },
    describeInfoObjChange(lang, value) {
      this.describeInfoObj[lang] = value;
      this.describeInfo = JSON.stringify(this.describeInfoObj);
      this.$forceUpdate();
    },
    getSucessInfoBananr(lang, data) {
      //上传成功
      this.projectDetailObj.banner[lang] = data;
      //   this.$forceUpdate();
    },
    getSucessInfo(data) {
      //上传成功
      this.form.picUrl = data;
      this.$forceUpdate();
    },
    getChainTypeList() {
      api.getChainType().then(res => {
        this.chainTypeList = res.data;
      });
    },
    closeBox() {
      // 清空表单数据
      this.$refs.form.resetFields();
      this.form = {};
      this.form.languageObj = ["zh"];
      this.languages = Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      }));
      this.languagesObj = LANGUAGES;
      this.nameObj = {};
      this.name = "";
      this.creator = "";
      this.creatorObj = {};
      this.describeInfo = "";
      this.describeInfoObj = {};
      this.$emit("closeBox");
    },
    getInfo(id) {
      api.getNFTInfo({ id: id }).then(res => {
        this.form = res.data;
        this.form = Object.assign(this.form, res.data);
        this.$set(this.form, "languageObj", JSON.parse(res.data.language));
        this.nameObj = Object.assign(
          this.nameObj,
          JSON.parse(res.data.rewardName)
        );
        this.name = res.data.rewardName
        this.creatorObj = res.data.creator ? Object.assign(
          this.creatorObj,
          JSON.parse(res.data.creator)
        ) : {};
        this.creator = res.data.creator
        this.describeInfoObj = res.data.describeInfo ? Object.assign(
          this.describeInfoObj,
          JSON.parse(res.data.describeInfo)
        ) : {};
        this.describeInfo = res.data.describeInfo
        this.$forceUpdate();
      });
      this.$emit("getInfo");
    },
    submitForm(formName) {
      if (!this.form.picUrl) {
        return this.$message({
          message: "请上传图片",
          type: "error"
        });
      }
      if (
        Object.keys(this.nameObj).length <
        Object.keys(this.form.languageObj).length ||
        !this.nameObj[this.form.languageObj[0]]
      ) {
        return this.$message({
          message: "请输入名称",
          type: "error"
        });
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = this.form;
          data.language = JSON.stringify(this.form.languageObj);
          data.rewardName = this.name;
          data.creator = this.creator;
          data.describeInfo = this.describeInfo;
          api.createOrUpdate(data).then(res => {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.getList()
          });
          this.$refs.form.resetFields();
          this.form = {};
          this.form.languageObj = ["zh"];
          this.languages = Object.keys(LANGUAGES).map(lang => ({
            label: LANGUAGES[lang],
            value: lang
          }));
          this.languagesObj = LANGUAGES;
          this.nameObj = {};
          this.name = "";
          this.creator = "";
          this.creatorObj = {};
          this.describeInfo = "";
          this.describeInfoObj = {};
          this.isTrue = true;
          this.$emit("submit", this.isTrue);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
    this.getChainTypeList();
  }
};
</script>
<style lang="less">
.nftinfo {
  .el-input.width300 {
    width: 300px;
    .el-input__inner {
      width: 100%;
    }
  }
  .el-form-item__content {
    position: relative;
  }
  .star {
    position: absolute;
    left: -48px;
    color: #f56c6c;
  }
}
</style>